<div class="ui-g ui-fluid">
  <div class="ui-g-12 background" style="padding: 30px; margin-bottom: 15px;">
    <div class="ui-g-12">
      <h2 class="title" >{{this.titleProvider}}</h2>
      <h3 class="subTitle">{{this.subTitleProvider}}</h3>
    </div>
  </div>
 <!--  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4 ui-lg-3">
      <div class="cardBlue2 ui-g-12" (click)="navigate($event,'2')" style="cursor: pointer;">
        <div class="align ui-g-12"><img class="center" src="../../assets/images/provider/hospitales.png" /></div>
        <div class="ui-g-12 fondo1"><h4 class="subTitle2">HOSPITALES</h4></div>
      </div>
    </div>
    <div class="ui-g-12 ui-md-4 ui-lg-3">
      <div class="cardBlue ui-g-12" (click)="navigate($event,'1')" style="cursor: pointer;">
        <div class="align ui-g-12"><img class="center" src="../../assets/images/provider/doctores.png" /></div>
        <div class="ui-g-12 fondo2"><h4 class="subTitle3">DOCTORES</h4></div>        
      </div>
    </div>
    <div class="ui-g-12 ui-md-4 ui-lg-3">
      <div class="cardBlue2 ui-g-12" (click)="navigate($event,'CAMPI')" style="cursor: pointer;">
        <div class="align ui-g-12"><img class="center" src="../../assets/images/provider/CAMPI.png" /></div>
        <div class="ui-g-12 fondo1"><h4 class="subTitle2">CAMPI</h4></div>
      </div>
    </div>
    <div class="ui-g-12 ui-md-4 ui-lg-3">
      <div class="cardBlue ui-g-12" (click)="navigate($event,'4')" style="cursor: pointer;">
        <div class="align ui-g-12"><img class="center" src="../../assets/images/provider/farmacias.png" /></div>
        <div class="ui-g-12 fondo2"><h4 class="subTitle3">FARMACIAS</h4></div>
      </div>
    </div>
    <div class="ui-g-12 ui-md-4 ui-lg-3">
      <div class="cardBlue2 ui-g-12" (click)="navigate($event,'3')" style="cursor: pointer;">
        <div class="align ui-g-12"><img class="center" src="../../assets/images/provider/laboratorios.png" /></div>
        <div class="ui-g-12 fondo1"><h4 class="subTitle2">LABORATORIOS</h4></div>
      </div>
    </div>
  </div> -->
  <iframe
frameborder="0" 
width="100%"
height="768"
style=" position: relative;"
        [src]="trustedUrl"
        allow='geolocation'>
</iframe>

</div>



